var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagingArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.469 6.219C5.53867 6.14915 5.62143 6.09374 5.71255 6.05593C5.80367 6.01812 5.90135 5.99866 6 5.99866C6.09865 5.99866 6.19633 6.01812 6.28745 6.05593C6.37857 6.09374 6.46133 6.14915 6.531 6.219L12 11.6895L17.469 6.219C17.6098 6.07817 17.8008 5.99905 18 5.99905C18.1992 5.99905 18.3902 6.07817 18.531 6.219C18.6718 6.35983 18.7509 6.55083 18.7509 6.75C18.7509 6.94916 18.6718 7.14017 18.531 7.281L12.531 13.281C12.4613 13.3508 12.3786 13.4063 12.2874 13.4441C12.1963 13.4819 12.0987 13.5013 12 13.5013C11.9013 13.5013 11.8037 13.4819 11.7125 13.4441C11.6214 13.4063 11.5387 13.3508 11.469 13.281L5.469 7.281C5.39915 7.21133 5.34374 7.12857 5.30593 7.03745C5.26812 6.94633 5.24866 6.84865 5.24866 6.75C5.24866 6.65135 5.26812 6.55367 5.30593 6.46255C5.34374 6.37143 5.39915 6.28867 5.469 6.219ZM1.5 17.25C1.5 17.0511 1.57902 16.8603 1.71967 16.7197C1.86032 16.579 2.05109 16.5 2.25 16.5H21.75C21.9489 16.5 22.1397 16.579 22.2803 16.7197C22.421 16.8603 22.5 17.0511 22.5 17.25C22.5 17.4489 22.421 17.6397 22.2803 17.7803C22.1397 17.921 21.9489 18 21.75 18H2.25C2.05109 18 1.86032 17.921 1.71967 17.7803C1.57902 17.6397 1.5 17.4489 1.5 17.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagingArrow);
export default __webpack_public_path__ + "static/media/MessagingArrow.55afd84802395dfaf10ea92382f40959.svg";
export { ForwardRef as ReactComponent };